import 'babel-polyfill';
import 'url-search-params-polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { EnvContextProvider } from 'next-common-lib';
import store from 'redux/store/configureStore';
import App from 'App';
import 'i18n';
import 'assets/style.scss';
import 'assets/privacy.css';
import 'assets/style/common.scss';
import 'assets/style/changeStyle';
import 'next-common-lib/dist/esm/common_lib_styles.css';

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <EnvContextProvider>
      <App />
    </EnvContextProvider>
  </Provider>,
);
